import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.279 5.096c2.136-.349 4.966.179 7.561.923a49 49 0 0 1 6.236 2.286l.763-1.395-1.447.002a.75.75 0 0 1-.75-.749.75.75 0 0 1 .748-.75l5.469-.006.077.004a.75.75 0 0 1 .001 1.493l-.076.003-2.31.002-1.138 2.078c.832.519 1.359 1.1 1.657 1.792.333.774.333 1.613.33 2.367.558.834.662 1.673.633 2.302-.034.727-.305 1.534-.942 2.088-.668.58-1.571.927-2.512 1.14-.833.189-1.751.28-2.668.321a4.5 4.5 0 0 1-8.386-.161H3.401a.75.75 0 1 1 0-1.5h2.851l-.001-.051a4.5 4.5 0 0 1 9 0l-.006.195c.715-.046 1.396-.13 2.004-.268.831-.188 1.459-.461 1.859-.809.245-.213.407-.584.428-1.025a2.27 2.27 0 0 0-.479-1.536.75.75 0 0 1-.155-.457c0-.937.01-1.505-.208-2.013-.194-.451-.627-.956-1.809-1.508a47 47 0 0 0-6.457-2.405c-2.567-.736-5.12-1.175-6.904-.884a.75.75 0 1 1-.242-1.48zm7.471 9.189a3 3 0 0 0 0 6 3 3 0 0 0 0-6"
}));
const ForwardRef = forwardRef(SvgComponent);
export const SpoilerIcon = ForwardRef;